export const removeMandatoryOptionText = `Pull over a sec… There are certain options on your new car that you
can't remove. When you start your order, you need to pick a paint
colour and an internal fabric design. And, whilst you can change the
colour/design super easily, you can’t just remove the options all
together;`;

export const initialPaymentTooltip =
  'This is a one-off payment to get your lease started. You can increase this to lower your monthly payments.';
export const numberOfPaymentTooltip =
  'The number of monthly payments you’ll make (excludes your initial payment).';
export const processingFeeTooltip =
  'A one-off charge to cover the admin required to process your order.';
export const excessMileageTooltip =
  'Travelled further than you told us? We’ll charge this per mile you went over.';
export const howLongTooltip =
  'This is the period the lease runs for. You’ll need to make monthly payments for this length of time.';
export const howFarTooltip =
  'Select the number of miles you expect to drive in a year. This will form part of your agreement and if you go over the allowed mileage, you’ll have to pay an excess mileage charge.';
export const howMuchInitialPaymentTooltip =
  'This is the first payment you’ll make as part of your lease agreement. The higher you go, the lower your monthly payments will be.';
export const carQuoteIdTooltip =
  'If you have any questions just quote this number and our team will locate your car in no time.';
export const totalCostOfLeaseTooltip =
  'This is the total of your monthly payments plus your initial payment. It includes {roadFundLicence}, if this increases throughout the term of the lease, the difference will be billed in a separate invoice.';
export const totalCostOfLeaseTooltipHyperLink =
  'https://www.gov.uk/vehicle-tax-rate-tables';
export const maintenanceTooltip =
  'Include all of your servicing and replacement tyres, for a simple monthly fee.';
export const evWLTPTooltip =
  'The actual range you will cover will depend on your driving style/environment, these figures are just a guide';
export const technicalTooltipQueryText = 'WLTP - Pure Electric Range';
